<ng-container [formGroup]="traduccionForm">
    <td [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="idiomas" [selectedItem]="traduccionForm.get('idioma')" [placeHolder]="false"></app-filterable-list>
    </td>
    <td [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="traduccion" title="{{'titles.traduccion' | translate}}">
    </td>
    <td class="actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardarTraduccion' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="far fa-trash-alt" title="{{'global.eliminar.descripcion' | translate}}" app-click-stop-propagation 
                (click)="askDelete(traduccion)"></i>
        </ng-container>
    </td>
</ng-container>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
</app-toast>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{'global.eliminar.descripcion' | translate}}</h4>
      </header>
      <content>
        <p>{{'global.eliminar.confirmacion' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>